module.exports = __webpack_public_path__ + "img/Support-skill-525.34306375.png";